import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import IdentityObject from "@/src/domain/common/identity-object";

export default abstract class ApiService extends IdentityObject {
  abstract getAxiosInstance(): AxiosInstance;
  abstract get<R, C = unknown>(
    endpoint: string,
    config?: Omit<AxiosRequestConfig, "params"> & {
      params?: C;
    }
  ): Promise<AxiosResponse<R>>;
  abstract post<R, T = object>(endpoint: string, data: T): Promise<AxiosResponse<R, T>>;

  abstract get blankAxios(): AxiosInstance;
}
